<div style="display:flex; align-items: center; flex-direction: column; margin-bottom: 30px;">
    <div class="headlines">Gene Normalizer</div>
    <form [formGroup]="ccsForm" (ngSubmit)="getDrugInfo()">
        <div class="form-group">
            <div class="textarea-div">
                <div style="display:flex; align-items: center;">
                    <div style="font-weight: bold;">Enter HUGO gene names.</div>
                    <mat-icon
                        matTooltip="Enter HUGO genes name, e.g. 'TP53' or click 'Load Example' to get a basic example."
                        matTooltipPosition="right" style="transform: scale(0.8);">help</mat-icon>
                </div>
                <textarea class="form-control" id="inputName" formControlName="inputName"
                    placeholder="Enter HUGO genes name, e.g. 'TP53' or click 'Load Example' to get a basic example."></textarea>
            </div>
            <div>
                <div>
                    <button type="button" class="btn btn-secondary" matTooltip="Info about the action"
                        matTooltipPosition="right" (click)="getExampleData()">Load Example</button><br>
                    <button type="submit" class="btn btn-primary" [disabled]="!ccsForm.valid">Submit</button>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="complete_request!=''">
    <app-terminal-view [terminal_string]="complete_request"></app-terminal-view>
</div>

<div class="card-grid" *ngIf="reqObj != null">
    <div class="card" *ngFor="let element of reqObj.data">
        <div class="card-header">
            <h2>{{element.name}}</h2>
        </div>
        <ul *ngIf="element['response']==200" style="margin-top: 10px;">
            <li> <span style="font-weight: bold;">Is Approved: </span> <span
                    [ngStyle]="{'color': (element['is_approved']=='False') ? 'red' : 'green'}">{{element['is_approved']}}</span>
            </li>
            <li>Approved Symbol: {{element['approved_symbol']}}</li>
            <li>Approved Name: {{element['approved_name']}}</li>
            <li>Chromosome: {{element['chromosome']}}</li>
            <li>HGNC ID: <a href="https://www.genenames.org/data/gene-symbol-report/#!/hgnc_id/{{element['hgnc_id']}}">{{element['hgnc_id']}}</a></li>
            <li *ngIf="element['previous_symbols'].length > 0" style="margin-top: 10px;">Previous Symbols:</li>
            <ul *ngIf="element['previous_symbols'].length > 0" style="margin-bottom: 10px;">
                <li *ngFor = "let symbol of element['previous_symbols']">{{symbol}}</li>
            </ul>
            <li *ngIf="element['alias_symbols']">Alias Symbols:</li>
            <ul *ngIf="element['alias_symbols']" style="margin-bottom: 10px;">
                <li *ngFor = "let symbol of element['alias_symbols']">{{symbol}}</li>
            </ul>

        </ul>
        <ul *ngIf="element['response']==400">
            <li style="color:red;">Error: {{element['error']}}</li>
        </ul>
    </div>
</div>